/*
 * 自动扫描当前文件夹及子文件夹下所有命名为【*.ruoter.js】文件
 * Date_: 2019-05-08 10:36:51
 */

const ctx = require.context('./', true, /\.router\.js$/)
let routeMappers = []

ctx.keys().forEach(item => {
    const obj = ctx(item)
    routeMappers = [...routeMappers, ...obj.default]
})

console.log('router', routeMappers)

export default routeMappers